import { Application } from './types';

export const PICKLEBALL_ENV = process.env.PICKLEBALL_ENV || process.env.NODE_ENV;
export const IS_PRODUCTION_LIB = PICKLEBALL_ENV === 'production';

export const NEXT_PUBLIC_IMAGE_CDN_URL = 'https://images.pickleball.com';

/**
 * SSO session cookies (JWT). JISID = impersonation session, JSID = normal session.
 * When both exist, JISID takes priority.
 */
export const JSID_COOKIE_KEY = 'JSID';
export const JISID_COOKIE_KEY = 'JISID';

export const applicationPrefixMap: Record<Application, string> = {
  pickleball: 'PB',
  tournament: 'PT',
  'team-leagues': 'PTL',
  clubs: 'PC',
  leagues: 'PL',
  'apr-rankings': 'APR',
};

export const errorImageVariants = [
  '404-error-image',
  '404-error-image-alt2',
  '404-error-image-alt3',
  '404-error-image-alt4',
] as const;
